import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "crm:relative crm:inline-block crm:max-w-full" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "card-header crm:bg-white! crm:p-4!"
}

import {ref, watch, useSlots} from 'vue'
import {generateID} from '../filters/common.filters.js'


export default {
  __name: 'BasePopover',
  props: {
  /**
   * forza il true/false del popover
   */
  value: {
    type: Boolean,
    default: false
  },
  /**
   * Classi personalizzate per il componente
   * @example {link: '...', container: '...', body: '...', footer: '...'}
   */
  customClasses: {
    type: [Array, Object],
    default() {
      return {}
    }
  }
},
  emits: [
  /**
   * emitta l'aggiornamento del toggle del valore
   */
  'update:value'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc Definisce un componente base per i popover
 */

const props = __props

const emits = __emit
const slots = useSlots();

const popOverValue = ref(props.value)
const popoverName = generateID('popover')
const customClass = ref(props.customClasses)

watch(props, (newValue) => {
  popOverValue.value = newValue.value
})

/**
 * Gestisce il toggle del popover
 */
function togglePopOver() {
  popOverValue.value = !popOverValue.value;
  emits('update:value', popOverValue.value)
}

/**
 * utilizzato per il click outside del popover
 */
function checkPopOver() {
  if(popOverValue.value) {
    popOverValue.value = false
  }
}

return (_ctx, _cache) => {
  const _directive_click_outside = _resolveDirective("click-outside")

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(["btn btn-navbar crm:max-w-full!", customClass.value['link'] !== undefined ? customClass.value.link : '']),
      href: "#",
      onClick: _withModifiers(togglePopOver, ["prevent"])
    }, [
      _createCommentVNode(" @slot permette di inserire una scritta,icona che attiverà al click il popover "),
      _renderSlot(_ctx.$slots, "cta")
    ], 2 /* CLASS */),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (popOverValue.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: _unref(popoverName),
              class: _normalizeClass(["popover-vue", customClass.value['container'] !== undefined ? customClass.value.container : ''])
            }, [
              (_unref(slots)['header'] !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createCommentVNode(" @slot permette di inserire un'intestazione al popover "),
                    _renderSlot(_ctx.$slots, "header")
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", {
                class: _normalizeClass(["card-body crm:overflow-y-auto! crm:border-y!", customClass.value['body'] !== undefined ? customClass.value.body : ''])
              }, [
                _createCommentVNode(" @slot permette di inserire un contenuto al popover "),
                _renderSlot(_ctx.$slots, "body")
              ], 2 /* CLASS */),
              (_unref(slots)['footer'] !== undefined)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["card-footer crm:bg-white! crm:py-4!", customClass.value['footer'] !== undefined ? customClass.value.footer : ''])
                  }, [
                    _createCommentVNode(" @slot permette di inserire un footer al popover "),
                    _renderSlot(_ctx.$slots, "footer")
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true)
            ], 10 /* CLASS, PROPS */, _hoisted_2))
          : _createCommentVNode("v-if", true)
      ]),
      _: 3 /* FORWARDED */
    })
  ])), [
    [_directive_click_outside, checkPopOver]
  ])
}
}

}